// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__K8","cls2":"AuthorHeader-cls2_Vm_ AuthorHeader-cls1__K8"};